import { IonButton } from "@ionic/react";

interface Props {
  setRemovePaper: Function;
}
const RemovePaperModal: React.FC<Props> = ({ setRemovePaper }) => {
  return (
    <>
      <div className="remove-paper-modal">
        <h1 className="fz-30 fw-700 align-center lh-normal">
          Remove the paper.
        </h1>
        <h1 className="fz-30 fw-700 align-center lh-normal mb-0">
          Walk back to the
        </h1>
        <h1 className="fz-30 fw-700 align-center lh-normal mt-0">
          start area.
        </h1>
        <h1 className="fz-30 fw-700 align-center lh-normal mb-0">
          {" "}
          Screen will flash
        </h1>
        <h1 className="fz-30 fw-700 align-center lh-normal mb-0">
          green when ready.
        </h1>
      </div>
    </>
  );
};
export default RemovePaperModal;
